"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateTerminalSettingsReducer = exports.createTerminalSettingsReducer = exports.fetchTerminalSettingsReducer = exports.updateTerminalSettingsSlice = exports.createTerminalSettingsSlice = exports.fetchTerminalSettingsSlice = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const terminalSettingsAction_1 = require("./terminalSettingsAction");
const fetchInitialState = {
    loading: false,
    error: null,
    data: []
};
const createInitialState = {
    loading: false,
    error: null,
    data: []
};
const updateInitialState = {
    loading: false,
    error: null,
    data: []
};
exports.fetchTerminalSettingsSlice = (0, toolkit_1.createSlice)({
    name: "terminalSettings/fetch",
    initialState: fetchInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(terminalSettingsAction_1.fetch.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        });
        builder.addCase(terminalSettingsAction_1.fetch.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        });
        builder.addCase(terminalSettingsAction_1.fetch.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.createTerminalSettingsSlice = (0, toolkit_1.createSlice)({
    name: "terminalSettings/create",
    initialState: createInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(terminalSettingsAction_1.create.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        });
        builder.addCase(terminalSettingsAction_1.create.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        });
        builder.addCase(terminalSettingsAction_1.create.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.updateTerminalSettingsSlice = (0, toolkit_1.createSlice)({
    name: "terminalSettings/update",
    initialState: updateInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(terminalSettingsAction_1.update.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        });
        builder.addCase(terminalSettingsAction_1.update.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        });
        builder.addCase(terminalSettingsAction_1.update.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.fetchTerminalSettingsReducer = exports.fetchTerminalSettingsSlice.reducer;
exports.createTerminalSettingsReducer = exports.createTerminalSettingsSlice.reducer;
exports.updateTerminalSettingsReducer = exports.updateTerminalSettingsSlice.reducer;
